import img01 from "../../../images/Productcard/image01.png"
import img002 from "../../../images/Productcard/image-002.png"
import img03 from "../../../images/Productcard/image03.png"
import img3 from "../../../images/Productcard/image3.png"
import images01 from "../../../images/Productcard/images-01.png"
import imgdesktop from "../../../images/Productcard/images-desktop.png"
import img001 from "../../../images/Productcard/image-001.png"
import img1 from "../../../images/Productcard/image1.png"
import img2 from "../../../images/Productcard/image2.png"
import img02 from "../../../images/Productcard/image02.png"

// static data for listing filter result
const CardList = [
  {
    mainClassName: "",
    slider: {
      videoID: "V8ksSGxo6no",
      videoImage: img02,
      pic: img01,
      slides: [img03, img03, img03],
    },
    propertyDetail: {
      h21: "Burkes Road",
      h22: "Beaconsfield",
      h23: "Buckinghamshire",
      subHead: "8 bedroom detached house for sale",
      propertyPrice: "Guide Price £6,250,000",
      availableSpace: [
        {
          spaceName: "Bedrooms",
          spaceQty: 8,
        },
        {
          spaceName: "Bathrooms",
          spaceQty: 6,
        },
        {
          spaceName: "Receptions",
          spaceQty: 3,
        },
        {
          spaceName: "Private Gated Development",
          spaceQty: "",
        },
      ],
      footerText: `
            An outstanding substantial family detached home set on one of
                  the most prestigious residential locations in South
                  Buckinghamshire and enjoying a 1 acre, south facing, mature
                  plot. Westmoreland House benefits from an extensive, southerly
                  facing secluded garden of approximately 1 Acre.
            `,
    },
  },
  {
    mainClassName: "",
    slider: {
      videoID: "V8ksSGxo6no",
      videoImage: img2,
      pic: img1,
      slides: [img3, img3, img3],
    },
    propertyDetail: {
      h21: "Main Drive",
      h22: "Gerrards Cross",
      h23: "Buckinghamshire",
      subHead: "8 bedroom detached house for sale",
      propertyPrice: "Guide Price £6,250,000",
      availableSpace: [
        {
          spaceName: "Bedrooms",
          spaceQty: 8,
        },
        {
          spaceName: "Bathrooms",
          spaceQty: 6,
        },
        {
          spaceName: "Receptions",
          spaceQty: 3,
        },
        {
          spaceName: "Private Gated Development",
          spaceQty: "",
        },
      ],
      footerText: `
            An outstanding substantial family detached home set on one of
                  the most prestigious residential locations in South
                  Buckinghamshire and enjoying a 1 acre, south facing, mature
                  plot. Westmoreland House benefits from an extensive, southerly
                  facing secluded garden of approximately 1 Acre.
            `,
    },
  },
  {
    mainClassName: "main",

    slider: {
      videoID: "V8ksSGxo6no",
      videoImage: img02,
      pic: images01,
      slides: [imgdesktop, imgdesktop, imgdesktop],
    },
    propertyDetail: {
      h21: "Burkes Crescent",
      h22: "Beaconsfield",
      h23: "Buckinghamshire",
      subHead: " 8 bedroom detached house for sale",
      propertyPrice: "Guide Price £6,250,000",
      availableSpace: [
        {
          spaceName: "Bedrooms",
          spaceQty: 8,
        },
        {
          spaceName: "Bathrooms",
          spaceQty: 6,
        },
        {
          spaceName: "Receptions",
          spaceQty: 3,
        },
        {
          spaceName: "Private Gated Development",
          spaceQty: "",
        },
      ],
      footerText: `
            An outstanding substantial family detached home set on one of
                  the most prestigious residential locations in South
                  Buckinghamshire and enjoying a 1 acre, south facing, mature
                  plot. Westmoreland House benefits from an extensive, southerly
                  facing secluded garden of approximately 1 Acre.
            `,
    },
  },
  {
    mainClassName: "long",
    slider: {
      videoID: "V8ksSGxo6no",
      videoImage: img001,
      pic: img001,
      slides: [img002, img002, img002],
    },
    propertyDetail: {
      h21: " Long Grove, Seer Green",
      h22: " Beaconsfield",
      h23: "Buckinghamshire",
      subHead: " 8 bedroom detached house for sale",
      propertyPrice: "Guide Price £6,250,000",
      availableSpace: [
        {
          spaceName: "Bedrooms",
          spaceQty: 8,
        },
        {
          spaceName: "Bathrooms",
          spaceQty: 6,
        },
        {
          spaceName: "Receptions",
          spaceQty: 3,
        },
        {
          spaceName: "Private Gated Development",
          spaceQty: "",
        },
      ],
      footerText: `
            An outstanding substantial family detached home set on one of
                  the most prestigious residential locations in South
                  Buckinghamshire and enjoying a 1 acre, south facing, mature
                  plot. Westmoreland House benefits from an extensive, southerly
                  facing secluded garden of approximately 1 Acre.
            `,
    },
  },
]
export default CardList
